import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnfermeiroPacientesComponent } from './subpages/enfermeiro-pacientes/enfermeiro-pacientes.component';
import { EnfermeiroCadastrarPacienteComponent } from './subpages/enfermeiro-cadastrar-paciente/enfermeiro-cadastrar-paciente.component';
import { EnfermeiroEditarPerfilComponent } from './subpages/enfermeiro-editar-perfil/enfermeiro-editar-perfil.component';
import { EnfermeiroAlterarPacienteComponent } from './subpages/enfermeiro-alterar-paciente/enfermeiro-alterar-paciente.component';
import { EnfermeiroAlterarCartaoGestanteComponent } from './subpages/enfermeiro-alterar-cartao-gestante/enfermeiro-alterar-cartao-gestante.component';
import { RoleGuard } from 'app/core/guards/role.guard';
import { EnfermeiroSecretariasComponent } from './subpages/enfermeiro-secretarias/enfermeiro-secretarias.component';

const routes: Routes = [
  {
    path: 'enfermeiro', 
    component: EnfermeiroPacientesComponent, 
    canActivate: [RoleGuard],
    data: { roles: ['enfermeiro'] }
  },
  {
    path: 'enfermeiro-cadastrar-pacientes', 
    component: EnfermeiroCadastrarPacienteComponent,
    canActivate: [RoleGuard],
    data: { roles: ['enfermeiro'] }
  },
  {
    path: 'enfermeiro-alterar-pacientes', 
    component: EnfermeiroAlterarPacienteComponent,
    canActivate: [RoleGuard],
    data: { roles: ['enfermeiro'] }
  },
  {
    path: 'enfermeiro-alterar-cartao-gestante', 
    component: EnfermeiroAlterarCartaoGestanteComponent,
    canActivate: [RoleGuard],
    data: { roles: ['enfermeiro'] }
  },
  {
    path: 'enfermeiro-editar-perfil', 
    component: EnfermeiroEditarPerfilComponent,
    canActivate: [RoleGuard],
    data: { roles: ['enfermeiro'] }
  },
  {
    path: 'enfermeiro-secretarias', 
    component: EnfermeiroSecretariasComponent,
    canActivate: [RoleGuard],
    data: { roles: ['enfermeiro'] }
  },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EnfermeiroRoutingModule { }
